module.exports = __webpack_public_path__ + "static/media/ql-icon-trivia.fdea7a5b.svg";